<script>
	import * as detectMobileMixin from '../shared/detect-mobile-mixin.vue';
	export default {
		props: ['pagedItems', 'loading', 'total', 'category'],
		mixins: [detectMobileMixin],
		data() {
			return {
				sortby: "- 排序 -",
				notFound: false
			};
		},
		mounted() {
			this.checkNotFoundStatus();
		},
		created: function() {},
		watch: {
			sortby: function(sortby) {
				if (sortby != '- 排序 -' && sortby != null) {
					this.$emit('sortByOnChange', sortby);
				} else if (sortby == null) {
					this.$emit('sortByOnChange', null);
					this.sortby = "- 排序 -";
				}
			},
			pagedItems: function(pagedItems) {
				this.checkNotFoundStatus();
			}
		},
		methods: {
			checkNotFoundStatus() {
				if (this.pagedItems) {
					if (this.pagedItems.length == 0) {
						this.notFound = true;
					} else {
						this.notFound = false;
					}
				} else {
					this.notFound = true;
				}
			},
			showDetails() {
				this.$emit('showDetails', true);
			},
			formatDuration(val) {
				if (!val) return '';
				return val;
			},
			formatFee(val) {
				if (!val) return '';
				let fee = String(val).replace(/<\/?[^>]+(>|$)/g, "").trim();
				return fee ? `學費: ${fee}` : '';
			}
		}
	}
</script>



// WEBPACK FOOTER //
// resources/js/course_new/CourseListViewMixin.vue